<div class="container-fluid recommendation-container">
  <form #mdf="ngForm" (ngSubmit)="saveData()">
    <div class="row m-0">
      <div class="col-md-6">
        <div class="recommendation-card positive-card">
          <div class="card-header positive-header d-flex justify-content-between align-items-center">
            <span><i class="fa fa-thumbs-up mr-2"></i>Positive</span>
            <button type="button" class="btn btn-sm add-btn" (click)="openAddModal('positive')"
              *ngIf="PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)">
              <i class="fa fa-plus mr-1"></i>Add
            </button>
          </div>
          <div class="card-body">
            <div *ngIf="PositiveRemarks.length === 0" class="text-muted text-center py-3">No positive remarks added yet</div>
            <div class="remark-item" *ngFor="let item of PositiveRemarks; let i = index">
              <span class="remark-text">{{ item.remark }}</span>
              <div class="remark-actions"
                *ngIf="PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)">
                <i class="fa fa-pencil-alt text-primary edit-icon" (click)="editRemark(i, 'positive')"></i>
                <i class="fa fa-trash text-danger delete-icon" (click)="deleteRemark(i, 'positive')"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="recommendation-card negative-card">
          <div class="card-header negative-header d-flex justify-content-between align-items-center">
            <span><i class="fa fa-thumbs-down mr-2"></i>Negative</span>
            <button type="button" class="btn btn-sm add-btn" (click)="openAddModal('negative')"
              *ngIf="PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)">
              <i class="fa fa-plus mr-1"></i>Add
            </button>
          </div>
          <div class="card-body">
            <div *ngIf="NegativeRemarks.length === 0" class="text-muted text-center py-3">No negative remarks added yet</div>
            <div class="remark-item" *ngFor="let item of NegativeRemarks; let i = index">
              <span class="remark-text">{{ item.remark }}</span>
              <div class="remark-actions"
                *ngIf="PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)">
                <i class="fa fa-pencil-alt text-primary edit-icon" (click)="editRemark(i, 'negative')"></i>
                <i class="fa fa-trash text-danger delete-icon" (click)="deleteRemark(i, 'negative')"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <ng-container *ngIf="hasRemarks">
      <div class="row m-0 mt-3">
        <div class="col-md-12">
          <span class="required-lable">Final Remark</span>
          <textarea #refFinalRemark="ngModel" rows="2" name="FinalRemark" id="FinalRemark" [(ngModel)]="FinalRemark" required
          [disabled]="!(PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true))"
          class="form-control input-text-css" placeholder="Enter final remark..."
          [ngClass]="{
            'is-invalid': mdf.submitted && refFinalRemark.invalid,
            'alert-warning': refFinalRemark.invalid && (refFinalRemark.dirty || refFinalRemark.touched || refFinalRemark.untouched)
          }"></textarea>
        </div>
      </div>
      <div class="row m-0 mt-3">
        <div class="col-md-6">
          <span class="required-lable">Recommendation Type</span>
          <select #refRecommendationType="ngModel" name="RecommendationType" id="RecommendationType" [(ngModel)]="RecommendationType" required
            [disabled]="!(PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true))"
            class="form-control input-text-css"
            [ngClass]="{
              'is-invalid': mdf.submitted && refRecommendationType.invalid,
              'alert-warning': refRecommendationType.invalid && (refRecommendationType.dirty || refRecommendationType.touched || refRecommendationType.untouched)
            }">
            <option value="">Select Recommendation Type</option>
            <option *ngFor="let type of RecommendationTypes" [value]="type.id">{{ type.value }}</option>
          </select>
        </div>
        <div class="col-md-6 d-flex align-items-end justify-content-end">
          <button type="submit" class="btn font-size-12 button-btn" [disabled]="!canSave"
            *ngIf="PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)">
            <i class="fa fa-save mr-1"></i>Save & Next
          </button>
          <button type="button" class="btn font-size-12 button-btn" (click)="onNext()"
            *ngIf="!(PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true))">
            Next <i class="fa fa-arrow-right ml-1"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <div class="row m-0 mt-3 justify-content-end"
      *ngIf="!(PageData?.currentTab == 1 && Status != 'C' && (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)) && !hasRemarks">
      <div class="col-md-12 text-right">
        <button type="button" class="btn font-size-12 button-btn" (click)="onNext()">
          Next <i class="fa fa-arrow-right ml-1"></i>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal-overlay" *ngIf="isModalVisible" (click)="closeModal()">
  <div class="modal-dialog-custom" (click)="$event.stopPropagation()">
    <div class="modal-content-custom">
      <div class="modal-header-custom modal-header">
        <h6 class="modal-title-custom">{{ isEditing ? 'Edit' : 'Add' }} {{ modalType === 'positive' ? 'Positive' : 'Negative' }} Remark</h6>
        <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true"><i class="far text-white fa-times-circle"></i></span>
        </button>
      </div>
      <div class="modal-body-custom">
        <span class="required-lable">Recommendation Remark</span>
        <textarea rows="4" name="newRemark" id="newRemark" [(ngModel)]="newRemark"
          class="form-control input-text-css" placeholder="Enter your remark..."></textarea>
      </div>
      <div class="modal-footer-custom">
        <button type="button" class="btn btn-sm button-btn btn-modal" style="border-radius: 9px!important; padding: 7px 15px!important;" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-sm button-btn btn-modal" style="border-radius: 9px!important; padding: 7px 15px!important;" (click)="saveRemark()">
          <i class="fa fa-save mr-1"></i>{{ isEditing ? 'Update' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
</div>
